<template>
    <div class="ntpReport">
        <template v-if="userPermission == 1">
            <div class="ntpReport-header">
                <lgn-input class="ntpReport-header-search" placeholder="請輸入場站代碼" v-model="searchText" 
                :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchNtpReport"
                @keyup.enter.native="searchNtpReport"></lgn-input>
                <a :href="`https://s3-ap-northeast-1.amazonaws.com/s3.paca.com.tw/period_report/${userInfo.id}_${serverTime}.tgz`" v-if="haveService" class="ntpReport-header-download main-button" target="_blank">當月報表 <i class="el-icon-download"></i></a>
            </div>
            <div class="paca-table">
                <div class="paca-table__header">
                    <div class="paca-table__header-item item-column column-name">{{$t("table.header.siteName")}}</div>
                    <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                    <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                    <div class="paca-table__header-item item-column column-report">報表</div>
                    <div class="paca-table__header-item item-column column-pause">停用</div>
                </div>
                <div class="paca-table__body" v-if="ntpListView.length != 0">
                    <div class="paca-table__body-col" v-for="(item, index) in ntpListView" :key="ntpSearchMode+index">
                        <div class="paca-table__body-col-list">
                            <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{item.name}}</div>
                            <div class="paca-table__body-col-list-item item-column column-site">{{item.site}}</div>
                            <div class="paca-table__body-col-list-item item-column column-vendor">{{item.vendor}}</div>
                            <div class="paca-table__body-col-list-item item-column column-report">
                                <a :href="`https://s3-ap-northeast-1.amazonaws.com/s3.paca.com.tw/period_report/${item.site}_${serverTime}.tgz`" target="_blank" :download="`${item.site}_${serverTime}.tgz`" class="el-icon-receiving column-report-icon"></a>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-pause">
                                <button class="column-pause-icon" @click="closeNtpreport(item, index)"></button>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="ntpReportListIteration()">更多</button>
                </div>
                <div class="paca-table__empty" v-else></div>
            </div>
        </template>
        <template v-else-if="userPermission == 0">
            <div class="ntpReport-description">
                <div class="ntpReport-description-item">
                    <p class="ntpReport-description-item-title">什麼是新北報表</p>
                    <p class="ntpReport-description-item-content">
                        因應新北市政府對各停車場分時、延時回報規定，該服務讓使用者下載可直接回報給新北市政府的統計報表，減少人工作業的時間。使用者亦可針對各單一場站，決定是否啟用新北報表功能。
                    </p>
                </div>
                <div class="ntpReport-description-item">
                    <p class="ntpReport-description-item-title">如何開啟報表功能</p>
                    <p class="ntpReport-description-item-content">為確保資料使用之安全性，新北報表服務需要核對會員身分。</p>
                    <p class="ntpReport-description-item-content">
                        請 Email:
                         <a href="mailto:service@berryan.com" target="_blank">service@berryan.com</a> 
                        提供您的註冊帳號、公司名稱，或代管場站名稱，我們將為您開啟此功能。
                    </p>
                </div>
            </div>
        </template>
        <template v-else-if="userPermission == -1"></template>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
export default {
    name: "ntpReport",
    components: {
        lgnInput
    },
    data(){
        return{
            ntpList: {
                all: [],
                search: []
            },
            viewNtpList: {
                all: [],
                search: []
            },
            tableLoading: false,
            ntpSearchMode: "all",
            searchText: "",
            viewMoreCount: 0,
            isShowMoreButton: true,
            serverTime: "",
            haveService: true,
            userPermission: -1
        }
    },
    methods: {
        searchNtpReport(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            let searchText = this.searchText;
            this.ntpSearchMode = "search";
            this.viewNtpList.search = [];
            let searchedList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            setTimeout(function(){
                this.ntpList.all.forEach(item => {
                    if(item.site.indexOf(searchText) != -1){
                        searchedList.push(item);
                    }
                })
                this.tableLoading = false;
                setTimeout(function(){
                    this.ntpList.search = searchedList;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        },
        ntpReportListIteration(){
            if((this.viewMoreCount + 1)*30 > this.ntpList[this.ntpSearchMode].length){
                this.isShowMoreButton = false;
            }
            this.viewNtpList[this.ntpSearchMode] = this.viewNtpList[this.ntpSearchMode].concat(this.ntpList[this.ntpSearchMode].slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        closeNtpreport(item, index){
            this.$confirm(`即將停用 ${item.name} 之新北回報功能`,"停用功能", {
                confirmButtonText: "確認停用",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let data = {
                    id: item.extra_info.id,
                    services_reports : 0
                }
                let res = await api.putAdminRegExtraInfoServiceReport(data);
                if(!res.error_status){
                    this.ntpListView.splice(index,1);
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        },
        pageLoading(value){
            let loadingStyle = "full-height";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.ntpReport',
                    text: '讀取中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        }
    },
    computed: {
        ntpListView(){
            return this.viewNtpList[this.ntpSearchMode]
        },
        userInfo(){
            return this.$store.state.userInfo
        }
    },
    async activated(){
        this.userPermission = -1;
        this.pageLoading(true);
        this.viewMoreCount = 0;
        this.isShowMoreButton = true;
        this.viewNtpList.all = [];
        this.viewNtpList.search = [];
        this.$nextTick(() => {
            this.tableLoading = true;
        })
        let res = await api.getNtpReportList();
        if(!res.error_status){
            res.sort(function(a, b){
                if(a.site > 7){
                    return 1
                } else if(a.site > b.site){
                    return 1
                } else if(a.site < b.site){
                    return -1
                } else {
                    return 0
                }
            })
            setTimeout(function(){
                this.tableLoading = false;
                setTimeout(function(){
                    this.pageLoading(false);
                    this.userPermission = 1;
                    this.ntpList.all = res;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        } else if(res.error_status == '403'){
            this.pageLoading(false);
            this.userPermission = 0;
            this.haveService = false;
            this.tableLoading = false;
        } else if(res.error_status != '401' && res.error_status != '504'){
            this.pageLoading(false);
            this.userPermission = 0;
            this.$message.error({
                duration: 2500,
                showClose: true,
                message: "發生錯誤!"
            })
            this.tableLoading = false;
        }
        let userRes = await api.getUserLogin();
        if(!userRes.error_status){
            let ServerTime = userRes.server_time;
            console.log(userRes.server_time);
            let serverMonth = ServerTime.split("").slice(5,7).join("") - 1;
            serverMonth = serverMonth < 10 ? '0' + serverMonth : serverMonth;
            let serverYear = ServerTime.split("").slice(0,4).join("");
            console.log(serverYear, serverMonth);
            if(serverMonth == '00'){
                serverYear -= 1;
                serverMonth = '12';
            }
            
            this.serverTime = `${serverYear}_${serverMonth}`;
        }
    },
    watch: {
        tableLoading(value){
            if(document.querySelector(".ntpReport-header")){
                let hasData = document.querySelector(".paca-table__body");
                let loadingStyle = "";
                let asideWidth = document.querySelector(".el-aside").offsetWidth;
                if(hasData){
                    loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
                }
                if(asideWidth > 150){
                    loadingStyle += " collapse-open";
                }else if(asideWidth > 50){
                    loadingStyle += " collapse-exist";
                }
                if(value == true){
                    this.loadingMethod = this.$loading({
                        lock: true,
                        target: '.paca-table__empty',
                        text: '搜尋中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255,255,255,0.8)',
                        customClass: loadingStyle
                    });
                }else{
                    if(this.loadingMethod != null){
                        this.loadingMethod.close();
                    }
                }
            }
        }
    },
}
</script>